import React, { useState } from "react";

import "./Users.css";
import "../../Components/Commons/Commons.css";

import BtnAdd from "../../Components/Commons/Buttons/BtnAdd";
import SidebarMenu from "../../Components/Sidebar/Sidebar";
import AntDTable from "../../Components/AntDTable/AntDTable";
import BtnSave from "../../Components/Commons/Buttons/BtnSave";
import BtnDelete from "../../Components/Commons/Buttons/BtnDelete";
import DeleteModal from "../../Components/Modals/DeleteModal";

import { Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
  deleteUser,
  getUsers,
} from "../../Components/Helpers/API/UserApi/UserApi";
import { getUser } from "../../Helpers/Utils/Common";

function Users() {
  const navigate = useNavigate();
  const [showDelete, setShowDelete] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [listUsers, setListUsers] = useState([]);
  const [rowId, setRowId] = useState("");
  const userId = getUser();


  // function for adding button in the table
  function ActionBtn(row) {
    return (
      <>
        <Row className="center">
          <Col>
            <BtnSave
              id={"green-btn"}
              label={"Edit"}
              size={"sm"}
              onClick={(e) => navigate("/users/edit/" + row.row.id)}
              disabled={userId !== row.row.id}
            />
          </Col>
          <Col>
            <BtnDelete
              outline
              label={"Delete"}
              size={"sm"}
              onClick={(e) => handleModal(row.row.id)}
              // disabled={userId === row.row.id}
              disabled
            />
          </Col>
        </Row>
      </>
    );
  }

  //get user API
  async function fetchUser() {
    setShowLoader(true);
    const response = await getUsers();
    if (response.data) {
      setListUsers(response.data.data);
      setShowLoader(false);
    } else {
      setShowLoader(false);
      setListUsers([]);
    }
  }

  const handleModal = (row) => {
    setRowId(row);
    setShowDelete(true);
  };

  //Delete user API
  async function handleDelete() {
    const response = await deleteUser(rowId);
    if (response.data) {
      toast.success(response.data.message);
      setShowDelete(false);
      fetchUser();
    } else if (response.error) {
      response.error.data.messages.error_messages.forEach((errMsg) => {
        toast.error(errMsg);
      });
    }
  }

  React.useEffect(() => {
    fetchUser();
  }, []);

  return (
    <div className="App">
      <SidebarMenu active={"Users"} />
      <div className="col p-5 pt-4 scrollable-container">
        <div className="row p-3 pt-2">
          <div className="col all-patient font-big title-2">User Manager</div>
          <div className="col-2 align-wb-right patient-manager pt-1">
            <BtnAdd
              label={"+ Add User"}
              size={"sm"}
              onClick={() => navigate("/users/add")}
            />
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-sm-12 all-table">
            <AntDTable
              tableHeaders={["FULL NAME", "USERNAME", "ROLE"]}
              headerSelector={["full_name", "username", "role_name"]}
              tableData={listUsers}
              ActionBtn={(row) => ActionBtn(row)}
              withAction={true}
              loading={showLoader}
            />
          </div>
        </div>
      </div>
      <DeleteModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        title={"Do you want to delete this user?"}
        onDelete={handleDelete}
      />
    </div>
  );
}

export default Users;
